<div class="flex-grow-1 pe-1 me-1 w-100 d-flex align-items-center" style="max-width: calc(100% - 15px);">
    <div class="text-truncate">
        <ng-content></ng-content>
    </div>
</div>

<div class="flex-grow-0 position-absolute end-0 w-auto px-1">
    <dx-button icon="bi bi-x-lg" (onClick)="close()"></dx-button>
</div>
